const serverSideFeatureToggles = {
  HOMEPAGE_SIMPLE_CALCULATOR_TEST: 'homepage-simple-calculator-test',
  FDR_CHATBOT: 'ai-chat-test-2',
  LARGE_VS_SMALL_HERO_IMAGE: 'large-vs-small-hero-image',
  ENABLE_MEGA_MENU: 'acx-web-enable-mega-menu',
  TALK_TO_US: 'talk-to-us',
}

export const featureToggles = {
  BRAND_PAGES_MULTIVARIATE_AB: 'fdr-brand-page-multivariate-test',
  HOME_DATA_VISUALIZATION_AB: 'fdr-home-data-visualization-test',
  ARTICLE_SLIDER_BANNER_AB: 'fdr-article-slider-banner-test',
  HOMEPAGE_SLIDER_CTA: 'fdr-homepage-slider-cta-test',
  HOMEPAGE_HERO_CTA: 'fdr-homepage-hero-cta',
  CLIENT_LOGIN_CTA_ON_MOBILE_TOP_NAV: 'fdr-client-login-cta-on-mobile-top-nav',
  HOME_PAGE_REDESIGN: 'homepage-redesign-multi-variate-test',
  HOMEPAGE_PERSONALIZATION: 'fdr_pzn_test',
  PROSPECT_QUIZ_NUDGE: 'prospect-quiz-nudge',
  ...serverSideFeatureToggles,
}

export const featureTogglesValues = {
  'fdr-brand-page-multivariate-test': {
    defaultFeature: '1_control',
  },
  'fdr-homepage-slider-cta-test': {
    defaultFeature: 'control',
  },
  'fdr-home-data-visualization-test': {
    defaultFeature: 'control',
  },
  'fdr-article-slider-banner-test': {
    defaultFeature: 'control',
  },
  'fdr-homepage-hero-cta': {
    defaultFeature: 'control',
  },
  'fdr-client-login-cta-on-mobile-top-nav': {
    defaultFeature: 'control',
  },
  'homepage-redesign-multi-variate-test': {
    defaultFeature: 'control',
  },
  [featureToggles.HOMEPAGE_PERSONALIZATION]: {
    defaultFeature: 'control',
  },
  [featureToggles.HOMEPAGE_SIMPLE_CALCULATOR_TEST]: {
    defaultFeature: 'control',
  },
  [featureToggles.FDR_CHATBOT]: {
    defaultFeature: 'Control',
  },
  [featureToggles.LARGE_VS_SMALL_HERO_IMAGE]: {
    defaultFeature: 'control',
  },
  [featureToggles.ENABLE_MEGA_MENU]: {
    defaultFeature: 'control',
  },
  [featureToggles.TALK_TO_US]: {
    defaultFeature: 'control',
  },
  [featureToggles.PROSPECT_QUIZ_NUDGE]: {
    defaultFeature: 'off',
  },
}
